import { useFormContext } from "react-hook-form";
import { MoneyFieldProps } from "./Money.types";
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@shadcn/components/ui/form";
import { getValidationConfig } from "@forms/form-render/helpers/getValidationConfig";
import { getFieldHelperText } from "@forms/form-render/helpers/getFieldHelperText";
import { Label } from "@shadcn/components/ui/label";
import CurrencyInput from "react-currency-input-field";
import { getCurrencySymbol } from "@forms/form-render/utils/currencyUtils";

export const Money = ({ config, required, validation, label, name, disabled }: MoneyFieldProps) => {
  const { control } = useFormContext();
  const description = getFieldHelperText(config.helperText, required);
  const validationConfig = getValidationConfig(validation);

  const currencySymbol = getCurrencySymbol(config.currencyCode);
  const decimalScale = config.decimalPlaces;

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        ...validationConfig,
        required: {
          value: required,
          message: "This is a required field",
        },
      }}
      render={({ field }) => (
        <FormItem className="space-y-2">
          {label && <Label htmlFor={name}>{label}</Label>}
          <FormMessage />
          <FormControl>
            <CurrencyInput
              id={name}
              name={name}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
              placeholder={
                config.placeholder || `${currencySymbol} 0${decimalScale > 0 ? "." + "0".repeat(decimalScale) : ""}`
              }
              prefix={currencySymbol + " "}
              decimalsLimit={decimalScale}
              decimalScale={decimalScale}
              allowNegativeValue={false}
              disabled={disabled}
              onValueChange={field.onChange}
              value={field.value || ""}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
        </FormItem>
      )}
    />
  );
};
